/* eslint-disable react/no-danger */
import React from 'react';
import { ClaimContextProvider } from 'gatsby-theme-agria/src/context/ClaimContext';

// Note providers normall would go in wrap pageElement but we need the location
export const wrapPageElement = ({ element }) => <ClaimContextProvider>{element}</ClaimContextProvider>;
